// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesStyles } from "@awc/Overrides/Widgets/Cart/CartLines";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

cartLinesStyles.header = {
    itemCountText: {
        variant: "h3",
        forwardAs: "p",
    },
    divider: {
        css: css`
            padding-top: 24px;
        `,
    },
};
cartLinesStyles.headerWrapper = {
    css: css`
        border: none;
        padding: 0;
    `,
};

cartLinesStyles.wrapper = {
    css: css`
        ${xScreen("lte", "sm")} {
            margin-bottom: 24px;
        }
    `,
};
